import Component from '../abstracts/Component';

export default class ResetPwComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-login-dropdown',
      resetPwLayer: '.js-reset-pw-layer',
      formContainer: '#js-reset-form-container',
      form: '.js-reset-layer-form',
      trigger: '.js-forgot-pw',
      modalContainer: '.js-pw-reset-modal',
      resetPwBack: '.js-reset-pw-back'
    };
  }

   get CLASSES() {
    return {
      show: 'show',
      showPw: 'show-forgot-pw'
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.loginDropdown = $(this.SELECTORS.loginDropdown);
  }

  closeLayer() {
    this.main.removeClass(this.CLASSES.showPw);
  }


  openLayer(resp) {
    this.main.addClass(this.CLASSES.showPw);
    $(this.SELECTORS.formContainer).html(resp);
    setTimeout(() => {
      this.main.addClass(this.CLASSES.show);
    }, 50);
  }

  openModal(resp) {
    this.$emit(this.$customEvents.MODAL_EVENTS.show, {
      unsafeContent: resp
    });
  }

  closeModal(vex) {
    vex.find('.vex-close').trigger('click.closeModal');
  }

  bindEvents() {

    let ctx = this;

    $('body').on('click.showInput', this.SELECTORS.trigger, function(e) {
      e.preventDefault();
      let $elem = $(this);
      $elem.parent().parent().find('button').on('click', (e)=>{
        e.preventDefault();
      });

      $.ajax({
        url:  $elem.attr('href'),
        data: $elem.data(),
        dataType: "html",
        success: function (resp) {
          ctx.log('Resetpw...');
          if (ctx.$matchMedia(null, 'sm')) {
            ctx.openLayer(resp);
          } else {
            ctx.openModal(resp)
          }
          $elem.parent().parent().find('button').off('click');
        },
        error: function (xhr) {
          ctx.log(xhr);
        }
      });
     
    })

    $('body').on('submit.resetPw', ctx.SELECTORS.form, function (e) {
      e.preventDefault();
      let $this = $(this);
      let url = $this.attr('action');
      let thankyouTitle = $this.data('thankyouTitle');

      $.ajax({
        type: "POST",
        url: url,
        data: $this.serialize(),
        success: function (html) {
          ctx.log('Thanksss for resetpw...');
          if (ctx.$matchMedia(null, 'sm')) {
            $(ctx.SELECTORS.resetPwLayer).html($(html).find('#response-resetpw'))
          } else {
            $(ctx.SELECTORS.modalContainer).find('.modal-body').html($(html).find('#response-resetpw'))
            $(ctx.SELECTORS.modalContainer).find('h2').text('Thank you!')
          }
        },
        error: function (html) {
          ctx.log('Resetpw submit error ');
          ctx.log($this.serialize())
        }
      });
    });

    $('body').on('click.pwBack', this.SELECTORS.resetPwBack, function() {
      if (ctx.$matchMedia(null, 'sm')) {
        ctx.closeLayer();
      } else {
        ctx.closeModal($(this).closest('.vex'))
      }
      
    })

  }

  render() {
    this.bindEvents();
  }
}
